module.exports = __webpack_public_path__ + "static/media/error_group.9ca90436.png";